import {
    RULE_CATEGORIES_POST_FAILURE,
    RULE_CATEGORIES_POST_REQUEST,
    RULE_CATEGORIES_POST_SUCCESS,
} from 'actions';

const initialState = {
    isFetched: false,
    isFetching: false,
    hasErrors: false,
};

export const ruleCategoryPostReducer = (state = initialState, action) => {
    const {type, ruleCategory} = action;
    switch (type) {
        case RULE_CATEGORIES_POST_SUCCESS: {return {
            ...state,
            isFetched: true,
            isFetching: false,
            hasErrors: false,
            ruleCategory,
        }}

        case RULE_CATEGORIES_POST_REQUEST: {return {
            ...initialState,
            isFetching: true,
            hasErrors: false,
        }}

        case RULE_CATEGORIES_POST_FAILURE: {return {
            ...initialState,
            hasErrors: true,
        }}

        default: {return state}
    }
};
